import {Directive, ElementRef, HostListener, Renderer2} from '@angular/core';

@Directive({
  selector: '[toggleClass]',
})
export class ToggleClassDirective {
  constructor(private elRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('body:click', ['$event']) click(e: MouseEvent) {
    if (this.elRef.nativeElement.contains(e.target)) {
      this.renderer.addClass(this.elRef.nativeElement, 'active');
    } else {
      this.renderer.removeClass(this.elRef.nativeElement, 'active');
    }
  }
}
